import { useCallback, useState } from "react";

/**
 * Kendo Menu keeps a submenu open while a child item is focused.
 * Opening a new tab / navigating away restores that focus and reopens the menu.
 * Remounting on leaf select clears focus/hover state.
 */
export const useResetMenuOnLeafSelect = () => {
  const [menuKey, setMenuKey] = useState(0);

  const resetMenu = useCallback(() => {
    setMenuKey((key) => key + 1);
  }, []);

  const onSelect = useCallback((event: { item?: { items?: unknown[] } }) => {
    if (!event.item?.items?.length) {
      setMenuKey((key) => key + 1);
    }
  }, []);

  return { menuKey, onSelect, resetMenu };
};
